import styled from '@emotion/styled';
import {
  Row,
  Column,
  device,
  typography,
  Reveal,
  shouldForwardProp,
} from '@landsbankinn/ui';
import React from 'react';
import { Title } from '../../components/card/Card';

interface IProps {
  left: React.ReactNode;
  right?: React.ReactNode;
  isArticle?: boolean;
  align?: string;
  mergeTop?: boolean;
}

const Host = styled(Reveal, {
  shouldForwardProp: shouldForwardProp('div'),
})<{ isArticle?: boolean; mergeTop?: boolean }>``;

const Left = styled.div<{ noMargin: boolean }>`
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : '30px')};

  @media ${device.tablet} {
    margin-bottom: 0;
  }
`;

const Right = styled.aside`
  ${Title} {
    ${typography.bodyEditorial}
    font-weight: bold;
  }
`;

export const SliceWrapper = ({
  left,
  right,
  isArticle,
  align,
  mergeTop,
  ...rest
}: IProps) => {
  return (
    <Host isArticle={isArticle} mergeTop={mergeTop} {...rest}>
      <Row reverse={align === 'Left'}>
        <Column
          md={{
            width: isArticle ? 7 / 12 : 8 / 12,
            offset: isArticle ? 1 / 12 : 0,
            offsetRight: !isArticle && align === 'Left' ? 1 / 12 : 0,
          }}
        >
          <Left noMargin={!right} className="left">
            {left}
          </Left>
        </Column>

        {right && (
          <Column
            md={{
              width: isArticle ? 3 / 12 : 4 / 12,
              offset: isArticle ? 1 / 12 : 0,
            }}
          >
            <Right>{right}</Right>
          </Column>
        )}
      </Row>
    </Host>
  );
};
